import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { postRequest } from "./axios";

export type TypeMarcatura = {
  dataora: string;
  elaborata: "1" | "0";
  idcantiere: string;
  idoperatorecantiere: string;
  immagine_profilo: string;
  nomecantiere: string;
  nomecognome: string;
  presenza_oggi: string;
  tipo: "IN" | "OUT" | "PAUSESTART" | "PAUSEEND";
};

export const getTipoMarcatura = (tipo: string = "") => {

    let tipoMarcatura: string = "n.d."; 

    switch(tipo.toUpperCase()) {
  
      case "IN":
      case "PAUSEEND":
        tipoMarcatura = "in"; 
        break; 
      case "OUT": 
      case "PAUSESTART": 
        tipoMarcatura = "out"; 
        break; 
      default: tipoMarcatura = "n.d." 
    }

    return tipoMarcatura; 

}

export type PropsMarcature = {

  idoperatorecantiere: string | null;
  idcantiere: string | null;
  datada: string | null; 
  dataa: string | null; 

}

export const useMarcature = ({

  idoperatorecantiere = null,
  idcantiere = null, 
  datada = null, 
  dataa = null

} : PropsMarcature) => {

  const [isLoading, setLoadingStatus] = useState<boolean>(true);
  const [results, setResults] = useState<Array<TypeMarcatura>>([]); 

  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  
  useEffect(() => {

    setLoadingStatus(true); 

    scaricaMarcature(); 

  }, [idoperatorecantiere, idcantiere, datada, dataa])

  const scaricaMarcature = async () => {

    try {

      const result = await postRequest("/app/get_marcature", {idoperatorecantiere, idcantiere, data_inizio:datada, data_fine:dataa});

      setResults(result.data); 
      setLoadingStatus(false); 
  
    } catch (e) {

      navigate("/"); 
      enqueueSnackbar("Impossibile ottenere le marcature dell'operatore: " + e, { variant: "error" });

    }

  }

  return { results, isLoading, setLoadingStatus, setResults }

}